import React from 'react';
import { Sheet } from "react-modal-sheet";
import { Logo } from '../imports';
import { twMerge } from 'tailwind-merge';



const SheetWrapper = ({
  isOpen,
  setIsOpen,
  hasHeader = true,
  hasBackdrop = true,
  hasButton = false,
  buttons,
  hasCloseButton,

  children,

  resp,
  height,

  ...props
}) => {


  // const [wrapperOpen, setWrapperOpen] = useState<boolean>(isOpenHolder)

  const onClose = () => {
    setIsOpen(!isOpen)
  }

  return (
    <Sheet isOpen={isOpen} onClose={onClose} detent={height ? "full-height" : "content-height"} snapPoints={[800, 0]} initialSnap={0} /*   {...props} */ >
      <Sheet.Container className='*:bg-blakk z-[100]'>
        {hasHeader && <Sheet.Header className='' />}
        <Sheet.Content className={twMerge('bg-blakk ')}>
          <Sheet.Scroller draggableAt='both' className={twMerge('bg-blakk', resp && "resp")}>
            <div id="sheetHeader" className='flex w-full items-start justify-between paddingX mx-auto relative mb-10'>
              <div className='flex flex-col lg:flex-row w-full items-start  pr-5 flex-wrap'>
                {props.showLogo && <div className='flex center relative mt-2 mr-2'><Logo src="symbol" /></div>}
                {props.sheetTitle && <h2 className='h-fit w-full max-w-[15ch] text-balance=='>{props.sheetTitle}</h2>}
                {props.sheetDescr && <h4 className='max-w-[35ch] dim text-balance'>{props.sheetDescr}</h4>}
              </div>
              {hasCloseButton &&
                <button onClick={onClose} className='iconContainer  shrink-0 border mix-blend-difference z-[5] rounded-full'>
                  <i className='ri-xl flex center aspect-square ri-close-line' size={22} />
                </button>
              }
            </div>

            <div>

              {children}

            </div>


            {hasButton &&
              buttons
            }

          </Sheet.Scroller>
        </Sheet.Content>
      </Sheet.Container>
      {hasBackdrop && <Sheet.Backdrop className='!bg-black/80 cursor-alias ' onTap={onClose} />}
    </Sheet>
  )
}

export default SheetWrapper;